import { render, staticRenderFns } from "./ExternalContent.vue?vue&type=template&id=440d5b12&"
import script from "./ExternalContent.vue?vue&type=script&lang=js&"
export * from "./ExternalContent.vue?vue&type=script&lang=js&"
import style0 from "./ExternalContent.vue?vue&type=style&index=0&id=440d5b12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports